import { render } from "./CarouselSlider.vue?vue&type=template&id=9cf2c5c0&ts=true&lang=pug"
import script from "./CarouselSlider.vue?vue&type=script&lang=ts"
export * from "./CarouselSlider.vue?vue&type=script&lang=ts"

import "./CarouselSlider.vue?vue&type=style&index=0&id=9cf2c5c0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__